/**
 * components/wishlist/link-preview.tsx
 *
 * Compact chip row showing link domain, optional favicon, and optional title.
 * Per Section 12.3 — never full-width card, always a compact chip.
 */

interface LinkPreviewProps {
  linkUrl: string
  linkDomain: string | null
  linkFavicon: string | null
  linkTitle: string | null
}

export default function LinkPreview({ linkUrl, linkDomain, linkFavicon, linkTitle }: LinkPreviewProps) {
  return (
    <a
      href={linkUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="
        flex items-center gap-[6px] mt-[5px]
        bg-[#FAF8F4] border border-[#F4C0D1]
        rounded-[8px] px-[8px] py-[4px]
        w-fit max-w-full
        active:bg-[#FBEAF0]
        transition-colors duration-100
        touch-manipulation
      "
      onClick={(e) => e.stopPropagation()}
    >
      {linkFavicon && (
        <img
          src={linkFavicon}
          className="w-[12px] h-[12px] rounded-[2px] flex-shrink-0"
          alt=""
          onError={(e) => { (e.target as HTMLImageElement).style.display = 'none' }}
        />
      )}
      {linkDomain && (
        <span className="font-['DM_Sans'] text-[11px] text-[#7A5A62] truncate max-w-[120px]">
          {linkDomain}
        </span>
      )}
      {linkTitle && (
        <span className="font-['DM_Sans'] text-[11px] text-[#B89AA2] truncate max-w-[140px]">
          · {linkTitle}
        </span>
      )}
    </a>
  )
}
